export default __webpack_public_path__ + "static/cafe_36033-ebab50008b3d7ecf9096b5217c4c72cd.png";